import { render } from "./PersonCard.vue?vue&type=template&id=257fe93c&scoped=true&ts=true"
import script from "./PersonCard.vue?vue&type=script&lang=ts"
export * from "./PersonCard.vue?vue&type=script&lang=ts"

import "./PersonCard.vue?vue&type=style&index=0&id=257fe93c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257fe93c"]])

export default __exports__